import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Icon, UiText } from '@shared/ui';

import cls from '../ImportModal.module.css';
import { useFileDropInput } from './useFileDropInput';

interface FileDropInputProps {
    file: File | null;
    error?: string | null;
    onFileSelect: (fileList: FileList | null) => void;
}

export const FileDropInput = ({ file, error, onFileSelect }: FileDropInputProps) => {
    const { t } = useTranslation();

    const { inputRef, isDragOver, handleDrop, handleDragOver, handleDragLeave, handleDragEnter } =
        useFileDropInput(onFileSelect);

    return (
        <div
            className={cn(cls.fileInput, isDragOver && cls.dragOver, error && cls.error)}
            onClick={() => inputRef.current?.click()}
            onDragOver={handleDragOver}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            <input
                type="file"
                accept=".xls,.xlsx"
                ref={inputRef}
                onChange={(e) => onFileSelect(e.target.files)}
                style={{ display: 'none' }}
            />
            <div className={cls.fileInputWrapper}>
                {isDragOver ? (
                    <>
                        <Icon iconName="fileInput" />
                        <div className={cls.dragHint}>
                            <UiText variant="mediumPlain" tag="span" align="center">
                                {t('FileDropInput.return.fileInput.dragHint')}
                            </UiText>
                        </div>
                    </>
                ) : (
                    <>
                        <Icon iconName={file ? 'xlsIcon' : 'fileInput'} />
                        <UiText
                            variant="plain"
                            tag="span"
                            align="center"
                            classes={cn(file && cls.fileName)}
                        >
                            {error ||
                                (file
                                    ? file.name
                                    : t('FileDropInput.return.fileInput.placeholder'))}
                        </UiText>
                        {file && !error && (
                            <UiText
                                variant="plain"
                                tag="span"
                                align="center"
                                classes={cls.blueColor}
                            >
                                {t('FileDropInput.return.fileInput.changeFile')}
                            </UiText>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
